<template>
    <v-navigation-drawer
        v-model="drawerShown"
        app
        clipped
        mobile-breakpoint="960"
        width="205"
        class="primaryBackgroundColor">
        <v-list :flat="true">
            <v-list-item-group v-model="currentPage"
            :mandatory="mandatorySelection">
                <v-container class="pa-0"
                v-for="item in items"
                v-show="(!item.forSuperAdmin || isSuperAdmin)"
                :key="item.title">
                    <v-container v-if="item.separator" class="py-2">
                        <v-divider></v-divider>
                    </v-container>
                    <v-subheader v-if="isSuperAdmin && item.hash === 'mobile-app' && company" class="my-n1">{{company.name}}</v-subheader>
                    <v-list-item link
                    @click.stop="onMenuItemClick(item)"
                    color="indigo">
                        <v-list-item-icon class="mr-5">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-container>
            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import {ref, watch, computed, onMounted} from '@vue/composition-api';
    import eConfig from "../evention-config";
    import {useGet} from "feathers-vuex";
    
    export default {
        name: 'AppDrawer',
        props: {
            value: Boolean,
        },
        setup(props, {emit, root}) {
            const {Company} = root.$FeathersVuex.api;

            const drawerShown = ref(Boolean(props.value));

            watch(() => props.value, (newValue, oldValue) => {
                if (newValue != null && newValue !== oldValue) {
                    drawerShown.value = newValue;
                }
            });
            
            watch(drawerShown, (newValue, oldValue) => {
                if (newValue != null && newValue !== oldValue) {
                    emit('input', newValue);
                }
            });
            
            const filterByCompanyId = computed(() => root.$store.state.prefilledCompanyId);
            const {item: company} = useGet({model: Company, id: filterByCompanyId});

            const isSuperAdmin = computed(() => {
                return (root.$store.state.auth.user && root.$store.state.auth.user.permissions === eConfig.user.permission.super);
            });

            const items = [
                {forSuperAdmin: true, hash: 'user', title: root.$t('app_drawer.user'), icon: 'mdi-account-circle', route: {name: 'user-list'}, separator: false},
                {forSuperAdmin: true, hash: 'company', title: root.$t('app_drawer.company'), icon: 'mdi-domain', route: {name: 'company-list'}, separator: false},
                {forSuperAdmin: true, hash: 'mobile-app', title: root.$t('app_drawer.app'), icon: 'mdi-cellphone', route: {name: 'mobile-app-list'}, separator: true},
                {forSuperAdmin: true, hash: 'guest', title: root.$t('Guest Accounts'), icon: 'mdi-account-supervisor', route: {name: 'guest-list'}, separator: false},
                {forSuperAdmin: false, hash: 'event', title: root.$t('app_drawer.event'), icon: 'mdi-calendar', route: {name: 'event-list'}, separator: false},
                {forSuperAdmin: true, hash: 'feature', title: root.$t('app_drawer.feature'), icon: 'mdi-cogs', route: {name: 'feature-list'}, separator: true}
            ];
            
            const onMenuItemClick = (item) => {
                /*if (!root.$vuetify.breakpoint.mdAndUp) {
                    drawerShown.value = false;
                }*/
                root.$router.push(item.route);
            };
            
            const currentPage = ref(null)
            const mandatorySelection = ref(true);
            const hash = computed(() => root.$route.path);
            
            const setCurrentPageSelection = (newHash) => {
                if (newHash) {
                    const pageHash = newHash.split('/')[1];
                    
                    let pageIndex = items.findIndex(item => item.hash === pageHash);
                    let hashNameElement = document.querySelector('#hash-name');
                    
                    if (pageIndex >= 0) {
                        mandatorySelection.value = true;
                        currentPage.value = pageIndex;
                        if (hashNameElement) hashNameElement.innerHTML = items[pageIndex].title;
                    } else {
                        mandatorySelection.value = false;
                        currentPage.value = null;
                        if (hashNameElement) hashNameElement.innerHTML = '';
                    }
                }
            }
            
            watch(hash, (newHash) => {
                setCurrentPageSelection(newHash);
            });
            
            onMounted(() => {
                setCurrentPageSelection(hash.value);
            });

            return {
                drawerShown,
                items,
                onMenuItemClick,

                currentPage,
                mandatorySelection,
                isSuperAdmin,
                filterByCompanyId,
                company
            }
        },
    }
</script>